<template>
  <div class="item-item" :class="[item.attributes.item_type, zoomed ? 'zoomed' : '', embed && item.attributes.item_type == 'video' ? 'embed-video' : '' ]">
    <div
      data-testid="blurred-image"
      v-if="item.attributes.view_limit_reached && !isOwner"
    >
      <!-- do not show the actual drop image -->
      <img src="@img/blurred-drop.png">
    </div>
    <div class="content" @mouseenter="hover = true" @mouseleave="hover = false" :class="{'fixed': !zoomed}" v-else>
      <video-item v-if="item.attributes.item_type == 'video' || item.attributes.instant_video"
        :embed="embed"
        :id="item.id"
        :item="item"
        :autoplay="autoplay"
        :statid="statid"
        @videoEnded="onEnded($event)"
      ></video-item>

      <image-item
        v-else-if="item.attributes.item_type == 'image'"
        v-on:zoom="setZoom(true)"
        v-on:unzoom="setZoom(false)"
        :item="item"
      ></image-item>

      <pdf-item
        v-else-if="item.attributes.item_type == 'pdf'"
        :item="item"
        :cta="cta"
        :embed-thumbnail="embedThumbnail"
      ></pdf-item>

      <audio-item
        v-else-if="item.attributes.item_type == 'audio'"
        :item="item"
      ></audio-item>

      <generic-item
        v-else
        :item="item"
        :embed-thumbnail="embedThumbnail"
      ></generic-item>

      <div
        id="cta-wrapper"
        v-if="showCTA">
        <cta-button hover-only/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    VideoItem: () => import('./video_item'),
    ImageItem: () => import('@cmp/viewer/image_item'),
    PdfItem: () => import('./pdf_item'),
    GenericItem: () => import('./generic_item'),
    AudioItem: () => import('./audio_item'),
    CtaButton: () => import('./cta/cta_button'),
  },
  props: {
    embed: Boolean,
    item: Object,
    cta: Object,
    last_call_to_action: Object,
    use_last_settings: Boolean,
    statid: String,
    autoplay: Boolean,
    genericUrl: String,
    embedThumbnail: Boolean,
  },
  computed: {
    isOwner: function() {
      return (this.item.relationships?.user?.data?.id === this.$store.state?.user?.id === true);
    },
    showCTA: function(){
      const vm = this;
      if(vm.embed){ return false; }

     const showControl = vm.item.attributes.item_type == "video" ? vm.videoEnded : vm.hover;

     return vm.$root.cta.menuOpen || showControl;
    }
  },
  methods: {
    setZoom: function (value) {
      this.zoomed = value;

      // Unfortunately, we have to propagate again because the parent needs to hide the sidebar.
      // A future refactor (or rethink of the zoom feature) may take care of that.
      this.$emit(this.zoomed ? "zoom" : "unzoom");
    },
    onEnded: function(data) {
      this.$emit("video-ended", data);
      this.videoEnded = data;
    },
  },
  data() {
    return {
      zoomed: false,
      videoEnded: false,
      hover: false
    };
  },
};
</script>

<style scoped lang="scss">

#cta-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.item-item {
  position: relative;
  padding: 0 40px 1.25rem;
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;

  .content {
    width: 100%;
    position: relative;
  }
}

.item-item.zoomed {
  max-width: 100%;
  margin: 0;
  padding: 0;
}

.item-item:not(.zoomed) {
  max-width: 103.13rem;
  margin: 0 auto;
}

.item-item.embed-video {
  max-width: 100%;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;

  .content {
    width: 100%;
    height: 100%;
  }
}

@media only screen and (max-width : 767px) {
  div.item-item {
    margin-bottom: 15px;
  }
}
</style>
